var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftPlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96669 3.80127L10.1425 4.9821L5.94003 9.16627H17.2559V10.8329H5.94086L10.1425 15.0179L8.96669 16.1988L2.74169 9.9996L8.96669 3.80127Z",
    fill: "#0E0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftPlain);
export default __webpack_public_path__ + "static/media/arrowLeftPlain.661bbc0cdd93ae9d2a0eda24350e529a.svg";
export { ForwardRef as ReactComponent };